import UrlBuilder from 'tools/urlBuilder';
import { RuleDefinition } from 'controls/queryBuilder/ruleDefinition';
import { GetIncidentsArgs } from 'areas/incidents/IncidentsGridStore/api';

export function getDescriptions() {
	return [
		{
			jspUrl: 'include/Incidents/IncidentForm.jsp',
			bodyCssClass: 'cw_incident_module',
			url: '/incidents/:id',
			getModuleImport: () => import('./details'),
			routeId: 'incidents_details',
		},
		{
			url: '/incidents',
			getModuleImport: () => import('./pages/incidents-grid-page/incidentsGridPage'),
			routeId: 'incidents',
		},
	];
}

type IncidentsRouterListArgs = {
	accountId?: string;
	includeSubaccounts?: boolean;
	filters?: RuleDefinition;
	entityType?: GetIncidentsArgs['entityType'];
	entityId?: string;

	impactName?: string;
	status?: string[];
	tagsPayload?: string;
	untaggedOnly?: boolean;
};

export class IncidentsRouter {
	static details(incidentId: string) {
		return new UrlBuilder(`/incidents/${incidentId}`).build();
	}

	static createNew(contentCategory: string) {
		return new UrlBuilder(`/incidents/new`).add('contentCategory', contentCategory).build();
	}

	static list(args?: IncidentsRouterListArgs) {
		return new UrlBuilder(`/incidents`).addObject(args).build();
	}
}
